import { render } from "./Infobox.vue?vue&type=template&id=f0ca27e6"
const script = {}

import "./Infobox.vue?vue&type=style&index=0&id=f0ca27e6&lang=scss"

import exportComponent from "/Users/patricksantner/projects/alpbach-ticketshop-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__